import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import { Toaster } from "sonner";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import Onboarding from "@/pages/Onboarding";
import Quiz from "@/pages/Quiz";
import Roadmap from "@/pages/Roadmap";
import Careers from "@/pages/Careers";
import Colleges from "@/pages/Colleges";
import Chat from "@/pages/Chat";
import CreativeStudio from "@/pages/CreativeStudio";
import Compare from "@/pages/Compare";
import CalendarPage from "@/pages/Calendar";
import ShareParent from "@/pages/ShareParent";
import ParentView from "@/pages/ParentView";
import ParentAuth from "@/pages/ParentAuth";
import ParentDashboard from "@/pages/ParentDashboard";
import CareerCard from "@/pages/CareerCard";
import Simulator from "@/pages/Simulator";
import ProtectedRoute from "@/components/ProtectedRoute";
import Celebrate from "@/components/Celebrate";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />

      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/onboarding" element={<ProtectedRoute><Onboarding /></ProtectedRoute>} />
      <Route path="/quiz" element={<ProtectedRoute><Quiz /></ProtectedRoute>} />
      <Route path="/roadmap" element={<ProtectedRoute><Roadmap /></ProtectedRoute>} />
      <Route path="/careers" element={<ProtectedRoute><Careers /></ProtectedRoute>} />
      <Route path="/compare" element={<ProtectedRoute><Compare /></ProtectedRoute>} />
      <Route path="/creative-studio" element={<ProtectedRoute><CreativeStudio /></ProtectedRoute>} />
      <Route path="/colleges" element={<ProtectedRoute><Colleges /></ProtectedRoute>} />
      <Route path="/calendar" element={<ProtectedRoute><CalendarPage /></ProtectedRoute>} />
      <Route path="/chat" element={<ProtectedRoute><Chat /></ProtectedRoute>} />
      <Route path="/career-card" element={<ProtectedRoute><CareerCard /></ProtectedRoute>} />
      <Route path="/simulator" element={<ProtectedRoute><Simulator /></ProtectedRoute>} />
      <Route path="/share" element={<ProtectedRoute><ShareParent /></ProtectedRoute>} />

      {/* Public parent share view */}
      <Route path="/share/:token" element={<ParentView />} />

      {/* Parent auth */}
      <Route path="/parent/login" element={<ParentAuth />} />
      <Route path="/parent/dashboard" element={<ParentDashboard />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Celebrate />
          <Toaster position="top-right" richColors closeButton />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
